export default "__VITE_ASSET___3Nlu7_i__"